/* assets/theme.js */

"use strict";

/* ─── DynamicAdapt ─────────────────────────────────────────────── */
function DynamicAdapt(t) { this.type = t; }

DynamicAdapt.prototype.init = function () {
  const t = this;
  this.оbjects = [];
  this.daClassname = "_dynamic_adapt_";
  this.nodes = document.querySelectorAll("[data-da]");

  for (let t = 0; t < this.nodes.length; t++) {
    const e = this.nodes[t],
          n = e.dataset.da.trim().split(","),
          a = {};
    a.element     = e;
    a.parent      = e.parentNode;
    a.destination = document.querySelector(n[0].trim());
    a.breakpoint  = n[1] ? n[1].trim() : "767";
    a.place       = n[2] ? n[2].trim() : "last";
    a.index       = this.indexInParent(a.parent, a.element);
    this.оbjects.push(a);
  }

  this.arraySort(this.оbjects);
  this.mediaQueries = Array.prototype.map.call(this.оbjects, function (t) {
    return "(" + this.type + "-width: " + t.breakpoint + "px)," + t.breakpoint;
  }, this);
  this.mediaQueries = Array.prototype.filter.call(this.mediaQueries, function (t, e, n) {
    return Array.prototype.indexOf.call(n, t) === e;
  });

  for (let e = 0; e < this.mediaQueries.length; e++) {
    const n = this.mediaQueries[e],
          a = String.prototype.split.call(n, ","),
          i = window.matchMedia(a[0]),
          r = a[1],
          s = Array.prototype.filter.call(this.оbjects, function (t) {
            return t.breakpoint === r;
          });
    i.addEventListener("change", function () { t.mediaHandler(i, s); });
    this.mediaHandler(i, s);
  }
};

DynamicAdapt.prototype.mediaHandler = function (t, e) {
  if (t.matches) {
    for (let t = 0; t < e.length; t++) {
      const n = e[t];
      n.index = this.indexInParent(n.parent, n.element);
      this.moveTo(n.place, n.element, n.destination);
    }
  } else {
    for (let t = 0; t < e.length; t++) {
      const n = e[t];
      if (n.element.classList.contains(this.daClassname)) this.moveBack(n.parent, n.element, n.index);
    }
  }
};

DynamicAdapt.prototype.moveTo = function (t, e, n) {
  e.classList.add(this.daClassname);
  if ("last" === t || t >= n.children.length) {
    n.insertAdjacentElement("beforeend", e);
  } else if ("first" === t) {
    n.insertAdjacentElement("afterbegin", e);
  } else {
    n.children[t].insertAdjacentElement("beforebegin", e);
  }
};

DynamicAdapt.prototype.moveBack = function (t, e, n) {
  e.classList.remove(this.daClassname);
  void 0 !== t.children[n]
    ? t.children[n].insertAdjacentElement("beforebegin", e)
    : t.insertAdjacentElement("beforeend", e);
};

DynamicAdapt.prototype.indexInParent = function (t, e) {
  return Array.prototype.indexOf.call(Array.prototype.slice.call(t.children), e);
};

DynamicAdapt.prototype.arraySort = function (t) {
  if ("min" === this.type) {
    Array.prototype.sort.call(t, function (t, e) {
      return t.breakpoint === e.breakpoint
        ? t.place === e.place ? 0 : "first" === t.place || "last" === e.place ? -1 : "last" === t.place || "first" === e.place ? 1 : t.place - e.place
        : t.breakpoint - e.breakpoint;
    });
  } else {
    Array.prototype.sort.call(t, function (t, e) {
      return t.breakpoint === e.breakpoint
        ? t.place === e.place ? 0 : "first" === t.place || "last" === e.place ? 1 : "last" === t.place || "first" === e.place ? -1 : e.place - t.place
        : e.breakpoint - t.breakpoint;
    });
  }
};

/* ─── FAQ ───────────────────────────────────────────────────────── */
function initFaq() {
  document.querySelectorAll(".faq-question").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      const item   = this.closest(".faq-item");
      const answer = item.querySelector(".faq-answer");
      const isOpen = item.classList.contains("is-active");

      /* close all siblings first */
      item.closest(".faq-list") && item.closest(".faq-list")
        .querySelectorAll(".faq-item.is-active")
        .forEach(function (openItem) {
          if (openItem !== item) {
            openItem.classList.remove("is-active");
            openItem.querySelector(".faq-answer").style.display = "none";
            openItem.querySelector(".faq-question").setAttribute("aria-expanded", "false");
          }
        });

      item.classList.toggle("is-active", !isOpen);
      answer.style.display = isOpen ? "none" : "block";
      btn.setAttribute("aria-expanded", String(!isOpen));
    });
  });
}

/* ─── Header ────────────────────────────────────────────────────── */
function initHeader() {
  const menu    = document.querySelector(".header-menu");
  const burger  = document.querySelector(".header-burger");
  const close   = document.querySelector(".header-close");
  const hasSubItems = document.querySelectorAll(".header-item--has-submenu");
  const toggles = document.querySelectorAll(".header-link--toggle");

  if (!menu || !burger) return;

  burger.addEventListener("click", function (e) {
    e.preventDefault();
    menu.classList.add("active");
  });

  close && close.addEventListener("click", function (e) {
    e.preventDefault();
    menu.classList.remove("active");
    hasSubItems.forEach(function (item) {
      item.classList.remove("active");
      const sub = item.querySelector(".header-sublist");
      if (sub) sub.style.display = "none";
    });
  });

  toggles.forEach(function (toggle) {
    toggle.addEventListener("click", function (e) {
      e.preventDefault();
      const parent = this.closest(".header-item--has-submenu");
      const sub    = parent && parent.querySelector(".header-sublist");

      hasSubItems.forEach(function (item) {
        if (item !== parent) {
          item.classList.remove("active");
          const s = item.querySelector(".header-sublist");
          if (s) s.style.display = "none";
        }
      });

      if (parent) parent.classList.toggle("active");
      if (sub) sub.style.display = sub.style.display === "block" ? "none" : "block";
    });
  });
}

/* ─── Swiper instances ──────────────────────────────────────────── */
function initSwipers() {
  if (typeof Swiper === "undefined") {
    setTimeout(initSwipers, 50);
    return;
  }

  /* Experts */
  var expertsEl = document.querySelector(".experts-slider");
  if (expertsEl) {
    new Swiper(expertsEl, {
      slidesPerView: "auto",
      spaceBetween: 20,
      speed: 800,
      breakpoints: {
        1024: { spaceBetween: 40, slidesPerView: 3 }
      }
    });
  }

  /* Marquee / line */
  var lineEl = document.querySelector(".line-slider");
  if (lineEl) {
    new Swiper(lineEl, {
      slidesPerView: "auto",
      spaceBetween: 0,
      speed: 3000,
      loop: true,
      autoplay: { delay: 0, disableOnInteraction: false },
      breakpoints: {
        1024: { spaceBetween: 32 }
      }
    });
  }

  /* Products */
  var productsEl = document.querySelector(".products-slider");
  if (productsEl) {
    new Swiper(productsEl, {
      slidesPerView: 2,
      spaceBetween: 12,
      speed: 800,
      grabCursor: true,
      breakpoints: {
        1024: { slidesPerView: 3, spaceBetween: 20 }
      }
    });
  }

  /* PDP Why */
  var pdpWhyEl = document.querySelector(".pdpwhy-slider");
  if (pdpWhyEl) {
    new Swiper(pdpWhyEl, {
      slidesPerView: "auto",
      spaceBetween: 12,
      speed: 800,
      centeredSlides: true,
      breakpoints: {
        1024: { slidesPerView: 3, spaceBetween: 20, centeredSlides: false }
      }
    });
  }

  /* Results */
  var resultsEl = document.querySelector(".results-slider");
  if (resultsEl) {
    new Swiper(resultsEl, {
      slidesPerView: 1,
      spaceBetween: 15,
      speed: 800,
      loop: true,
      centeredSlides: true,
      autoplay: { delay: 1500, disableOnInteraction: false },
      navigation: {
        nextEl: ".results-btn--next",
        prevEl: ".results-btn--prev"
      },
      pagination: {
        el: ".results-pagination",
        clickable: true
      },
      breakpoints: {
        768:  { slidesPerView: "auto" },
        1024: { slidesPerView: 3, spaceBetween: 32 }
      }
    });
  }
}

/* ─── Boot ──────────────────────────────────────────────────────── */
document.addEventListener("DOMContentLoaded", function () {
  const da = new DynamicAdapt("max");
  da.init();
  initFaq();
  initHeader();
  initSwipers();
});